import { render, staticRenderFns } from "./CompletedSnag.vue?vue&type=template&id=435b184e&"
import script from "./CompletedSnag.vue?vue&type=script&lang=js&"
export * from "./CompletedSnag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports